import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import ContactBackground from "../../assets/store/ecommerce-cta.jpg";

const Contact = ({ primaryColor = "#43bd98" }) => {
	const { t } = useTranslation();

	return (
		<section
			id="contacto"
			style={{
				position: "relative",
				padding: "6rem 1rem",
				textAlign: "center",
				color: "#333",
				backgroundImage: `url(${ContactBackground})`,
				backgroundSize: "cover",
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
			}}
		>
			{/* Overlay */}
			<div
				style={{
					position: "absolute",
					inset: 0,
					background: "rgba(255,255,255,0.78)",
					backdropFilter: "blur(6px)",
					zIndex: 0,
				}}
			/>

			{/* Contenido */}
			<div
				style={{
					position: "relative",
					zIndex: 1,
					maxWidth: "700px",
					margin: "0 auto",
				}}
			>
				<motion.p
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.6 }}
					viewport={{ once: true }}
					style={{
						color: primaryColor,
						fontSize: "0.9rem",
						fontWeight: 600,
						letterSpacing: "1px",
						textTransform: "uppercase",
						marginBottom: 0,
					}}
				>
					{t("store.contact.badge")}
				</motion.p>

				<motion.h2
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, delay: 0.2 }}
					viewport={{ once: true }}
					style={{
						fontSize: "clamp(1.8rem, 5vw, 2.6rem)",
						color: "#222",
						fontWeight: 800,
						marginBottom: "1rem",
						marginTop: 20,
					}}
				>
					{t("store.contact.title")}
				</motion.h2>

				<motion.p
					initial={{ opacity: 0, y: 20 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, delay: 0.4 }}
					viewport={{ once: true }}
					style={{
						maxWidth: "500px",
						margin: "0 auto 2.5rem",
						color: "#555",
						lineHeight: 1.7,
					}}
				>
					{t("store.contact.description")}
				</motion.p>

				<motion.div
					initial="hidden"
					whileInView="show"
					viewport={{ once: true }}
					transition={{ staggerChildren: 0.2 }}
					style={{
						display: "flex",
						justifyContent: "center",
						gap: "1rem",
						flexWrap: "wrap",
					}}
				>
					<motion.a
						href="https://wa.me/34608916357"
						target="_blank"
						rel="noopener noreferrer"
						whileHover={{ scale: 1.05 }}
						whileTap={{ scale: 0.95 }}
						style={{
							padding: "0.9rem 1.8rem",
							backgroundColor: "#25D366",
							color: "#fff",
							borderRadius: "8px",
							fontWeight: 600,
							fontSize: "1rem",
							textDecoration: "none",
						}}
					>
						{t("store.contact.whatsapp")}
					</motion.a>

					<motion.a
						href="mailto:info@applaby.com"
						whileHover={{ scale: 1.05 }}
						whileTap={{ scale: 0.95 }}
						style={{
							padding: "0.9rem 1.8rem",
							backgroundColor: primaryColor,
							color: "#fff",
							borderRadius: "8px",
							fontWeight: 600,
							fontSize: "1rem",
							textDecoration: "none",
						}}
					>
						{t("store.contact.email")}
					</motion.a>
				</motion.div>
			</div>
		</section>
	);
};

export default Contact;
